import { lazy } from 'react';

const calculator = lazy(() => import('pages/calculator/Calculator'));
const createReturnLabel = lazy(() => import('pages/calculator/CreateReturnLabel'));
const createLabel = lazy(() => import('pages/calculator/CreateLabel'));

export { calculator, createLabel, createReturnLabel };
